import { EventEmitter, Injectable, Output, Directive } from '@angular/core';
import { StarbaseNotificationService, StarbaseNotificationTypes } from 'starbase-notification';
import { StarbaseModalButton, StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalTypes } from 'starbase-modal-dialog';
import { IMessage, StarbaseComponentMessage, UserAccountModel } from 'starbase-launcher';
import { Subject } from 'rxjs';
import { AppGlobalsService } from '../app-globals.service';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class StarbaseComponentMessageService {

  /** Emits when a non-quiet message has been received but not handled by this service.
   * Often this is for displaying messages directly on a component template. */
  @Output() messageForUserEmitter = new EventEmitter<IMessage>();

  /** Emits when a quiet command message has been received but not handled by this service.
   * Often this is interpreted by an individual component. */
  @Output() messageCommandEmitter = new EventEmitter<IMessage>();

  @Output() recordHistoryEmitter = new EventEmitter<string>(); // emits the GUID to look up
  @Output() manageUserEmitter = new EventEmitter<UserAccountModel>();

  constructor(private notiSvc: StarbaseNotificationService,
    private modalSvc: StarbaseModalDialogService,
    private appGlobalsSvc: AppGlobalsService) { }

  public handleStarbaseComponentMsg(msg: IMessage) {
    console.log(`Starbase Cmp Msg received: ${msg.message}`);
    if (msg.quiet) {
      this.handleMessageCommands(msg);
      return;
    }
    if (msg instanceof StarbaseComponentMessage) {
      if ((msg as StarbaseComponentMessage).showAsNotification) {
        this.handleMessageNotify(msg);
      } else if ((msg as StarbaseComponentMessage).showAsModal) {
        this.handleMessageModal(msg);
      }
    } else {
      this.messageForUserEmitter.emit(msg);
    }
  }

   /** Used when confirming the deletion of lookup table data or requisite data from a data pane.
    * Not used for root record data.
    */
    public dataDeleteConfirm(event: { title: string; msg: string; obs: Subject<boolean> }) {
      this.modalSvc.postModal(new StarbaseModalOptions(
        event.title,
        event.msg,
        [
          new StarbaseModalButton(
            'Delete',
            () => {
              event.obs.next(true);
              this.modalSvc.closeModal('User pressed Delete.');
            }
          ),
          new StarbaseModalButton(
            'No',
            () => {
              event.obs.next(false);
              this.modalSvc.closeModal('User cancelled.');
            }
          )
        ],
        StarbaseModalTypes.Warning
      ));
    }

  private handleMessageNotify(msg: IMessage): void {
    const theNotification = this.notiSvc.notificationBuilder(
      msg.title || 'Message from Starbase Module',
      msg.message
    );
    if (msg.error) {
      theNotification.type = StarbaseNotificationTypes.Error;
      theNotification.duration = 7500;
    } else if (msg.success) {
      theNotification.type = StarbaseNotificationTypes.Success;
      theNotification.duration = 4000;
    } else if (msg.warning) {
      theNotification.type = StarbaseNotificationTypes.Warning;
      theNotification.duration = 7000;
    } else if (msg.message.includes('birthday')) {
      if (this.appGlobalsSvc.getStoredBirthdayNoticeSetting()) {
        theNotification.type = StarbaseNotificationTypes.Info;
        theNotification.duration = 7000;
      } else {
        return;
      }
    }
    this.notiSvc.postNotification(theNotification);
  }

  private handleMessageModal(msg: IMessage): void {
    const theModal = new StarbaseModalOptions(
      msg.title,
      msg.message
    );
    if (msg.error) {
      theModal.type = StarbaseModalTypes.Error;
    } else if (msg.warning) {
      theModal.type = StarbaseModalTypes.Warning;
    } else if (msg.success) {
      theModal.type = StarbaseModalTypes.Success;
    } else {
      theModal.type = StarbaseModalTypes.Notice;
    }
    this.modalSvc.postModal(theModal);
  }

  private handleMessageCommands(msg: IMessage): void {
    this.messageCommandEmitter.emit(msg);
  }

}
